function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLgChHearthealthyhero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "75pt",
    height: "75pt",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.941176%,82.745098%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 31.5 44.460938 C 34.222656 39.144531 40.679688 35.574219 46.613281 32.09375 C 52.546875 28.613281 58.613281 24.445312 60.023438 18.847656 C 61.816406 11.609375 54.144531 4.386719 44.785156 2.941406 C 35.421875 1.492188 25.425781 4.921875 18.847656 10.351562 C 14.46875 13.964844 11.347656 19.539062 14.691406 23.632812 C 16.835938 26.242188 21.148438 27.5625 22.875 30.382812 C 25.199219 34.132812 10.359375 25.933594 6.046875 28.558594 C 4.328125 29.609375 3.699219 34.191406 3.5625 39.320312 L 3.5625 39.324219 C 3.371094 49.46875 7.679688 59.179688 15.335938 65.84375 L 16.835938 67.1875 C 18.726562 68.867188 20.699219 70.59375 23.332031 71.523438 C 26.40625 72.617188 29.976562 72.484375 33.382812 72.324219 C 41.957031 71.933594 50.902344 71.4375 58.351562 68.0625 C 71.476562 62.109375 75.601562 47.003906 66.660156 37.785156 C 65.644531 36.65625 64.394531 35.765625 63 35.175781 C 59.023438 33.675781 54.066406 35.414062 50.878906 37.882812 C 46.890625 40.964844 44.4375 45.1875 44.128906 49.492188 C 43.949219 52.171875 28.746094 49.769531 31.5 44.460938 Z M 31.5 44.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.529412%,50.196078%,84.705882%)",
      fillOpacity: 1
    },
    d: "M 69.816406 50.371094 C 68.25 53.453125 66.113281 56.941406 62.667969 57.21875 C 60.964844 57.347656 59.195312 56.617188 57.558594 57.113281 L 57.5625 57.113281 C 56.734375 57.386719 56.003906 57.890625 55.449219 58.558594 C 53.792969 60.359375 52.75 63.117188 50.371094 63.703125 L 50.25 63.75 C 47.699219 64.273438 45.511719 61.933594 43.410156 60.324219 C 43.152344 60.109375 42.871094 59.925781 42.570312 59.773438 C 42.277344 59.621094 41.953125 59.535156 41.625 59.511719 C 40.929688 59.5625 40.261719 59.796875 39.691406 60.195312 C 39.210938 60.464844 38.695312 60.734375 38.191406 60.945312 C 35.785156 62.039062 33.023438 62.609375 31.125 60.945312 C 29.714844 59.699219 29.199219 57.503906 27.886719 56.324219 C 27.570312 56.035156 27.195312 55.8125 26.789062 55.679688 C 26.300781 55.523438 25.769531 55.515625 25.289062 55.355469 C 23.25 54.75 22.824219 52.246094 22.28125 50.25 L 22.242188 50.144531 C 21.296875 46.738281 19.167969 43.816406 17.066406 40.980469 L 11.25 33.105469 C 9.457031 30.683594 7.589844 28.011719 7.679688 24.996094 C 7.769531 21.980469 10.035156 19.175781 12.816406 17.804688 C 15.597656 16.433594 18.816406 16.257812 21.898438 16.46875 C 27.101562 16.84375 32.171875 18.261719 36.808594 20.648438 C 38.835938 21.6875 40.769531 22.90625 42.578125 24.292969 L 43.785156 24.660156 C 47.101562 24.796875 50.535156 25.644531 52.964844 27.90625 C 55.515625 30.277344 56.574219 33.816406 57.34375 37.222656 C 58.117188 40.628906 58.769531 44.167969 60.75 47.023438 C 61.550781 48.160156 62.59375 49.105469 63.800781 49.792969 C 65.597656 50.945312 67.835938 51.160156 69.816406 50.371094 Z M 69.816406 50.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,56.470588%,100%)",
      fillOpacity: 1
    },
    d: "M 63.824219 49.792969 C 63.324219 49.871094 62.8125 49.839844 62.324219 49.703125 C 55.46875 47.835938 54.148438 40.269531 49.574219 32.722656 C 45 25.175781 37.148438 28.574219 37.148438 28.574219 L 35.289062 21.074219 L 36.789062 20.652344 L 36.789062 20.65625 C 38.816406 21.695312 40.746094 22.914062 42.554688 24.300781 L 43.761719 24.667969 C 47.078125 24.804688 50.511719 25.652344 52.941406 27.914062 C 55.492188 30.285156 56.550781 33.824219 57.320312 37.230469 C 58.09375 40.636719 58.769531 44.167969 60.75 47.023438 C 61.558594 48.164062 62.609375 49.109375 63.824219 49.792969 Z M 63.824219 49.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,37.254902%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 55.449219 58.558594 C 53.792969 60.359375 52.75 63.117188 50.371094 63.703125 L 50.25 63.75 C 50.550781 59.542969 51.546875 50.316406 42.5625 41.183594 C 40.042969 38.617188 32.0625 35.5 31.621094 34.859375 C 30.929688 33.890625 36.261719 34.859375 39.046875 36.359375 C 39.046875 36.359375 51.796875 38.925781 55.164062 57.871094 Z M 55.449219 58.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,37.254902%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 42.554688 59.753906 C 42.261719 59.601562 41.941406 59.511719 41.609375 59.488281 C 40.914062 59.539062 40.246094 59.777344 39.675781 60.171875 C 39.195312 60.441406 38.679688 60.710938 38.175781 60.921875 C 37.246094 56.347656 34.734375 50.121094 28.703125 42.449219 C 28.703125 42.449219 29.714844 31.882812 32.542969 33.980469 C 33.601562 34.730469 34.558594 45.636719 37.148438 48.117188 C 40.28125 51.171875 41.355469 54.433594 42.554688 59.753906 Z M 42.554688 59.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,37.254902%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 27.847656 56.332031 C 27.53125 56.042969 27.160156 55.820312 26.753906 55.6875 C 26.265625 55.53125 25.734375 55.523438 25.253906 55.363281 C 23.25 54.75 22.824219 52.246094 22.273438 50.25 C 22.222656 48.960938 20.160156 45.113281 19.964844 43.640625 C 19.351562 38.984375 19.914062 35.902344 17.300781 29.390625 C 17.300781 29.347656 29.65625 35.863281 27.847656 56.332031 Z M 27.847656 56.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 93.088542 67.161458 C 91 71.270833 88.151042 75.921875 83.557292 76.291667 C 81.286458 76.463542 78.927083 75.489583 76.744792 76.151042 L 76.75 76.151042 C 75.645833 76.515625 74.671875 77.1875 73.932292 78.078125 C 71.723958 80.479167 70.333333 84.15625 67.161458 84.9375 L 67 85 C 63.598958 85.697917 60.682292 82.578125 57.880208 80.432292 C 57.536458 80.145833 57.161458 79.901042 56.760417 79.697917 C 56.369792 79.494792 55.9375 79.380208 55.5 79.348958 C 54.572917 79.416667 53.682292 79.729167 52.921875 80.260417 C 52.28125 80.619792 51.59375 80.979167 50.921875 81.260417 C 47.713542 82.71875 44.03125 83.479167 41.5 81.260417 C 39.619792 79.598958 38.932292 76.671875 37.182292 75.098958 C 36.760417 74.713542 36.260417 74.416667 35.71875 74.239583 C 35.067708 74.03125 34.359375 74.020833 33.71875 73.807292 C 31 73 30.432292 69.661458 29.697917 67 L 29.697917 66.859375 C 28.4375 62.317708 25.588542 58.421875 22.796875 54.640625 L 15 44.140625 C 12.619792 40.911458 10.130208 37.348958 10.25 33.328125 C 10.369792 29.307292 13.390625 25.567708 17.098958 23.739583 C 20.807292 21.911458 25.098958 21.677083 29.208333 21.958333 C 39.21875 22.677083 48.802083 26.302083 56.78125 32.390625 L 58.390625 32.880208 C 62.8125 33.0625 67.390625 34.192708 70.630208 37.208333 C 74.03125 40.369792 75.442708 45.088542 76.46875 49.630208 C 77.5 54.171875 78.359375 58.890625 81 62.697917 C 83.640625 66.510417 88.838542 69.052083 93.088542 67.161458 Z M 93.088542 67.161458 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,38.039216%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 44.746094 21.863281 C 44.746094 22.976562 44.617188 24.089844 44.371094 25.175781 C 41.671875 37.5 24.96875 46.101562 24.96875 46.101562 C 24.96875 46.101562 6.511719 36.503906 5.25 23.25 C 5.203125 22.785156 5.191406 22.3125 5.191406 21.839844 C 5.21875 17.085938 8.378906 12.917969 12.945312 11.597656 C 17.515625 10.277344 22.40625 12.125 24.96875 16.132812 C 27.527344 12.125 32.417969 10.277344 36.988281 11.597656 C 41.558594 12.917969 44.714844 17.085938 44.746094 21.839844 Z M 44.746094 21.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.078431%,27.843137%,5.098039%)",
      fillOpacity: 1
    },
    d: "M 36.578125 34.792969 C 35.605469 34.320312 34.53125 34.078125 33.449219 34.09375 C 31.140625 33.953125 28.820312 33.929688 26.503906 34.011719 C 23.8125 34.109375 20.742188 34.214844 18.867188 32.285156 C 16.753906 30.109375 16.992188 26.082031 14.367188 24.558594 C 12.867188 23.671875 10.910156 24.042969 9.117188 24.191406 L 9.121094 24.195312 C 7.871094 24.292969 6.613281 24.265625 5.371094 24.121094 C 7.304688 36.90625 24.96875 46.101562 24.96875 46.101562 C 29.804688 43.472656 34.214844 40.121094 38.046875 36.164062 C 37.65625 35.613281 37.15625 35.144531 36.578125 34.792969 Z M 36.578125 34.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 59.661458 29.151042 C 59.661458 30.635417 59.489583 32.119792 59.161458 33.567708 C 55.5625 50 33.291667 61.46875 33.291667 61.46875 C 33.291667 61.46875 8.682292 48.671875 7 31 C 6.9375 30.380208 6.921875 29.75 6.921875 29.119792 C 6.958333 22.78125 11.171875 17.223958 17.260417 15.463542 C 23.354167 13.703125 29.875 16.166667 33.291667 21.510417 C 36.703125 16.166667 43.223958 13.703125 49.317708 15.463542 C 55.411458 17.223958 59.619792 22.78125 59.661458 29.119792 Z M 59.661458 29.151042 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078431%,73.72549%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 38.183594 37.433594 L 11.746094 37.433594 L 8.316406 33.570312 L 41.617188 33.570312 Z M 38.183594 37.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 13.914062 33.863281 L 17.304688 33.863281 L 17.304688 37.304688 L 13.914062 37.304688 Z M 13.914062 33.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.27451%,66.27451%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 32.609375 33.863281 L 36 33.863281 L 36 37.304688 L 32.609375 37.304688 Z M 32.609375 33.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 50.911458 49.911458 L 15.661458 49.911458 L 11.088542 44.760417 L 55.489583 44.760417 Z M 50.911458 49.911458 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(96.078431%,73.72549%,25.490196%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 27.651042 43.4375 L 38.921875 43.4375 L 38.921875 51.21875 L 27.651042 51.21875 Z M 27.651042 43.4375 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 23.067708 45.151042 L 23.067708 49.75 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 18.552083 45.151042 L 18.552083 49.75 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 48 45.151042 L 48 49.75 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 43.479167 45.151042 L 43.479167 49.75 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 62.651042 54.880208 C 62.651042 54.880208 71.713542 62.192708 73.932292 77.671875 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 54.411458 72 C 55.286458 74.25 56.005208 76.552083 56.5625 78.901042 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 47.052083 59.291667 C 47.713542 61.25 48.729167 63.072917 50.052083 64.671875 C 50.765625 65.515625 51.432292 66.395833 52.052083 67.3125 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 37 63.130208 C 37.546875 66.979167 37.546875 70.890625 37 74.739583 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 58.328125 38.098958 C 58.328125 38.098958 63.729167 36.458333 70.328125 51.557292 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(3.529412%,50.196078%,84.705882%)",
      fillOpacity: 1,
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 13 34.390625 C 13 35.932292 10.9375 37.171875 8.390625 37.171875 C 5.838542 37.171875 5.682292 35.932292 5.682292 34.390625 C 5.682292 32.848958 5.84375 31.609375 8.390625 31.609375 C 10.9375 31.609375 13 32.859375 13 34.390625 Z M 13 34.390625 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.411765%,56.470588%,100%)",
      fillOpacity: 1
    },
    d: "M 40.289062 25.792969 C 40.289062 26.949219 41.839844 27.878906 43.753906 27.878906 C 45.667969 27.878906 45.75 26.949219 45.75 25.792969 C 45.75 24.636719 45.628906 23.707031 43.726562 23.707031 C 41.820312 23.707031 40.289062 24.644531 40.289062 25.792969 Z M 40.289062 25.792969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 61 34.390625 C 61 32.859375 60.838542 31.609375 58.302083 31.609375 C 55.760417 31.609375 53.682292 32.859375 53.682292 34.390625 C 53.682292 35.921875 55.75 37.171875 58.302083 37.171875 C 58.880208 37.203125 59.463542 37.104167 60 36.880208 ",
    transform: "matrix(0.75,0,0,0.75,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLgChHearthealthyhero);
export default __webpack_public_path__ + "static/media/ic_lg_ch_hearthealthyhero.8586f35046d0278335e7c19307d8e63c.svg";
export { ForwardRef as ReactComponent };